import { render, staticRenderFns } from "./AppMultipleItemsAnswer.vue?vue&type=template&id=51daaec8&scoped=true"
import script from "./AppMultipleItemsAnswer.vue?vue&type=script&lang=ts"
export * from "./AppMultipleItemsAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppMultipleItemsAnswer.vue?vue&type=style&index=0&id=51daaec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51daaec8",
  null
  
)

export default component.exports